import type { ChatMessageEvent } from '../types/chat';

/**
 * Chat message helpers — source 분기·표시 정책의 SSOT.
 *
 * ChatMessage OpenAPI schema 에 source 필드가 없으므로 isAi · senderId 로 파생.
 * MessageItem (sender label/badge/row class), MessageList (grouping break) 등 여러 곳에서
 * 같은 분기를 사용하므로 단일 헬퍼로 SSOT 화. schema 진화 (예: 명시 source 필드 도입) 시
 * 한 곳만 수정.
 */

export type MessageSource = 'user' | 'ai' | 'system';

/**
 * source 파생: ai (isAi=true) > system (senderId=null && !isAi) > user (else).
 */
export function getMessageSource(msg: Pick<ChatMessageEvent, 'isAi' | 'senderId'>): MessageSource {
  if (msg.isAi) return 'ai';
  if (msg.senderId === null) return 'system';
  return 'user';
}

/**
 * system 메시지 단축 판정 — 룸 생성·멤버 합류 등 (senderId=null + !isAi).
 * grouping break 정책에서 자주 사용.
 */
export function isSystemMessage(msg: Pick<ChatMessageEvent, 'isAi' | 'senderId'>): boolean {
  return getMessageSource(msg) === 'system';
}
